import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SimUsage } from '../../models/sim-usage';
import { Sim } from '../../models/sim';

@Component({
  selector: 'app-sim-data-details',
  template: require('./sim-data-details.component.html'),
  styles: [require('./sim-data-details.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimDataDetailsComponent implements OnInit {

  @Input() sim: Sim & SimUsage;
  @Input() from: Date;
  @Input() to: Date;
  
  constructor() { }

  ngOnInit(): void {
  }

}
